import UIRadioGroup, { UIRadio } from "components/custom-ui/UIRadioGroup";
import { FormContainer, FormRow } from "components/shared";
import {  UITextInput } from "components/ui";
import React from "react";
import {DisabledPrompt} from "bcms-react"
import { SVGAsset } from "res";

import "./styles.css";
import "./mobile.css";

/**
 * @function ImportFileFormatWidget
 * @return {React.Component}
 * @exported true
 * @description The Import File Format widget for the ImportFileNewTemplatePage.
 */
export default function ImportFileFormatWidget(props) {
    return (
        <div className="import-file-format-widget">
            <div className="flex-container flex-horizontal align-center widget-title">
                <h2 className="label-with-icon">File Format</h2>
                <SVGAsset id="InfoIcon" />
            </div>
            <FormContainer>
                <FormRow className="flex-horizontal align-center top-format-form-row">
                    <UIRadioGroup value="delimited">
                        <UIRadio className="ui-group-item" dataPoint={ `File_Format_Radio_Delimiter` } label="Delimited" value="delimited" />
                        <DisabledPrompt>
                        <UIRadio className="ui-group-item" dataPoint={ `File_Format_Radio_Fixed_Width` } label="Fixed Width" value="fixed width" />
                        </DisabledPrompt>

                    </UIRadioGroup>
                </FormRow>
                <FormRow className="flex-horizontal align-center bottom-format-form-row">
                    <UIRadioGroup value="comma">
                        <UIRadio className="ui-group-item" dataPoint={ `File_Format_Radio_Comma` } label="Comma" value="comma"/>
                        <DisabledPrompt>
                            <UIRadio className="ui-group-item" label="Tab" value="tab" />
                        </DisabledPrompt>
                        <DisabledPrompt>
                        <UIRadio className="ui-group-item" label="Semicolon" value="semicolon" />
                        </DisabledPrompt>
                        <DisabledPrompt>
                        <UIRadio className="ui-group-item" label="Space" value="space" />
                        </DisabledPrompt>
                        <DisabledPrompt>
                        <UIRadio className="ui-group-item" label="Other" value="other" />
                        </DisabledPrompt>
                        <UITextInput className="other-text-input" disabled />
                    </UIRadioGroup>
              
                </FormRow>
            </FormContainer>

        </div>
    )
}
